module.exports = __webpack_public_path__ + "media/application/images/icons/items-tree-pebble-dark-green-rgb-962b60153928da7710533d07b1a72384.svg";